module.exports = __webpack_public_path__ + "img/PPT版_02.21849aad.png";